/* SEYUN Volu-Lift offer: free gift lines follow the number of sticks in the cart, on every page (loaded by layout/theme.liquid).
   A pack = the "1 Stick" variant x quantity. Rule (validated plan, 25/10): collagen mask from 4 sticks; eye patches + neck mask from 6 sticks;
   1 of each gift at most; below the threshold the gift line is removed. Every cart line of a gift variant is managed
   (the gift products are only given with this offer). Test override: window.SEYUN_VL_SYNC_CONFIG. */
(() => {
  if (window.__seyunVlSync) return;
  const cfg = Object.assign({
    sticks: { '67792883581235': 1 },
    tag: 'volu-lift-offer',
    gifts: [
      { id: '67792883646771', min: 4, max: 1 }, // SEYUN Collagen Mask (Free Gift)
      { id: '67792883679539', min: 6, max: 1 }, // SEYUN Caffeine Collagen Eye Patches (Free Gift)
      { id: '67792883712307', min: 6, max: 1 }  // SEYUN Neck & Decollete Collagen Mask (Free Gift)
    ]
  }, window.SEYUN_VL_SYNC_CONFIG || {});
  window.__seyunVlSync = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let busy = false, timer, retries = 0;

  const css = document.createElement('style');
  css.id = 'svl-gift-lock';
  css.textContent = cfg.gifts.map(g => '.moonbundle-cart-item[data-item-key^="' + g.id + ':"] .moonbundle-cart-item-quantity-container,.moonbundle-cart-item[data-item-key^="' + g.id + ':"] .moonbundle-cart-item-remove-container').join(',') + '{display:none!important}';
  document.head.appendChild(css);

  async function readCart() {
    for (let i = 0; i < 4; i++) {
      try {
        const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (r.ok) return await r.json();
      } catch (e) {}
      await new Promise(r => setTimeout(r, 1200));
    }
    return null;
  }
  async function post(path, body) {
    const r = await fetch(root + path, { method: 'POST', headers: H, body: JSON.stringify(body) });
    if (!r.ok) throw new Error('cart ' + r.status);
    return r.json();
  }
  async function reconcile() {
    if (busy || window.__svlBusy) { schedule(600); return; }
    busy = true;
    try {
      const cart = await readCart();
      if (!cart) { if (retries++ < 3) schedule(3000); return; }
      retries = 0;
      const sticks = cart.items.reduce((s, i) => s + (cfg.sticks[String(i.variant_id)] || 0) * i.quantity, 0);
      let changed = false;
      for (const g of cfg.gifts) {
        const want = sticks >= g.min ? (g.max || 1) : 0;
        const lines = cart.items.filter(i => String(i.variant_id) === String(g.id));
        const have = lines.reduce((s, i) => s + i.quantity, 0);
        const tagged = lines.length && lines[0].properties && lines[0].properties._free_gift === cfg.tag;
        if (have === want && (want === 0 || (lines.length === 1 && tagged))) continue;
        if (want > 0 && (!lines.length || !tagged)) {
          for (const l of lines) await post('cart/change.js', { id: l.key, quantity: 0 });
          await post('cart/add.js', { items: [{ id: Number(g.id), quantity: want, properties: { _free_gift: cfg.tag } }] });
        } else if (want > 0) {
          await post('cart/change.js', { id: lines[0].key, quantity: want });
          for (const l of lines.slice(1)) await post('cart/change.js', { id: l.key, quantity: 0 });
        } else {
          for (const l of lines) await post('cart/change.js', { id: l.key, quantity: 0 });
        }
        changed = true;
      }
      if (changed) window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail: { caller: 'seyun-vl-sync' } }));
    } catch (e) { /* silent: never block the shopper */ }
    finally { busy = false; }
  }
  const schedule = (ms) => { clearTimeout(timer); timer = setTimeout(reconcile, ms || 400); };

  const orig = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = orig.apply(this, arguments);
    if (/\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(url)) p.then(() => scheduleUpsell(true), () => {});
    if (!busy && /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(url) && !/moonbundle_ignore/.test(url)) p.then(() => schedule(), () => {});
    return p;
  };
  window.addEventListener('moonbundle-cart-updated', e => { if (!(e.detail && /^seyun-vl-sync/.test(e.detail.caller || ''))) schedule(); });

  /* Cart upsell (Cédric 26/10): when the stick is in the Moon Bundle drawer, its "Complete your routine" list is replaced
     by the paid copies of the gifts the shopper does not already get (the free gift products stay 100 % off and offer-only). */
  const UPSELL = [
    { gift: '67792883646771', id: '67796229259571', handle: 'seyun-collagen-mask', sub: 'Collagen sheet mask' },
    { gift: '67792883679539', id: '67796229292339', handle: 'seyun-caffeine-collagen-eye-patches', sub: 'Under-eye patches' },
    { gift: '67792883712307', id: '67796229423411', handle: 'seyun-neck-chest-collagen-mask', sub: 'Neck & chest mask' }
  ];
  const upsellData = {};
  let upsellCart = null, upsellBusy = false;
  const cur = () => (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  const money = c => new Intl.NumberFormat('en', { style: 'currency', currency: cur(), currencyDisplay: 'narrowSymbol' }).format(c / 100);
  async function upsellProduct(u) {
    if (!upsellData[u.handle]) {
      upsellData[u.handle] = fetch(root + 'products/' + u.handle + '.js', { headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : null).catch(() => null);
    }
    return upsellData[u.handle];
  }
  async function renderUpsell() {
    const drawer = document.getElementById('moonbundle-cart-drawer');
    if (!drawer) return;
    const moon = drawer.querySelector('.moonbundle-cart-upsell:not(.svl-upsell)');
    const mine = drawer.querySelector('.svl-upsell');
    if (!upsellCart) upsellCart = await readCart();
    const cart = upsellCart;
    if (!cart) return;
    const ids = cart.items.map(i => String(i.variant_id));
    const hasStick = ids.some(id => cfg.sticks[id]);
    const todo = hasStick ? UPSELL.filter(u => !ids.includes(u.gift) && !ids.includes(u.id)) : [];
    if (moon) moon.style.display = todo.length || hasStick ? 'none' : '';
    const key = todo.map(u => u.id).join(',') + '|' + cur();
    if (mine && mine.dataset.key === key && drawer.contains(mine)) return;
    if (mine) mine.remove();
    if (!todo.length) return;
    const prods = await Promise.all(todo.map(upsellProduct));
    const box = document.createElement('div');
    box.className = 'moonbundle-cart-upsell svl-upsell';
    box.dataset.key = key;
    box.innerHTML = '<div class="moonbundle-cart-upsell-header"><div class="moonbundle-cart-upsell-title-row"><div class="moonbundle-cart-upsell-title">Complete your routine</div></div></div>' +
      '<div class="moonbundle-cart-upsell-products"><div class="moonbundle-cart-upsell-products-wrapper moonbundle-cart-upsell-products-wrapper--stacked">' +
      todo.map((u, i) => {
        const p = prods[i];
        if (!p) return '';
        const v = p.variants.find(x => String(x.id) === u.id) || p.variants[0];
        const img = (p.featured_image || '').replace(/^\/\//, 'https://');
        const url = root + 'products/' + u.handle;
        return '<div class="moonbundle-cart-upsell-product moonbundle-cart-upsell-product--vertical moonbundle-cart-upsell-product-current"><div class="moonbundle-cart-upsell-product-container">' +
          '<div class="moonbundle-cart-upsell-product-image-container"><a class="moonbundle-cart-upsell-product-image-link" href="' + url + '"><img class="moonbundle-cart-upsell-product-image" src="' + img + (img.includes('?') ? '&' : '?') + 'width=200" alt=""></a></div>' +
          '<div class="moonbundle-cart-upsell-product-details"><h4 class="moonbundle-cart-upsell-product-title"><a class="moonbundle-cart-upsell-product-title-link" href="' + url + '">' + p.title + '</a></h4>' +
          '<p class="moonbundle-cart-upsell-product-subtitle">' + u.sub + '</p><div class="moonbundle-cart-upsell-product-price-container">' +
          (v.compare_at_price > v.price ? '<p class="moonbundle-cart-upsell-product-original-price">' + money(v.compare_at_price) + '</p>' : '') +
          '<p class="moonbundle-cart-upsell-product-price">' + money(v.price) + '</p></div></div>' +
          '<div class="moonbundle-cart-upsell-add-to-cart-container"><button type="button" class="moonbundle-cart-upsell-add-to-cart-btn" data-svl-upsell="' + u.id + '">Add</button></div></div></div>';
      }).join('') + '</div></div>';
    const scroll = drawer.querySelector('.moonbundle-cart-body-scrollable');
    if (moon && moon.parentElement) moon.parentElement.insertBefore(box, moon); else if (scroll) scroll.appendChild(box); else return;
  }
  const scheduleUpsell = (() => { let t; return (fresh) => { if (fresh) upsellCart = null; clearTimeout(t); t = setTimeout(renderUpsell, 300); }; })();
  document.addEventListener('click', async e => {
    const b = e.target.closest && e.target.closest('[data-svl-upsell]');
    if (!b || upsellBusy) return;
    e.preventDefault(); upsellBusy = true; b.disabled = true;
    try {
      await post('cart/add.js', { items: [{ id: Number(b.dataset.svlUpsell), quantity: 1 }] });
      window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail: { caller: 'seyun-vl-sync-upsell' } }));
    } catch (err) { b.disabled = false; }
    finally { upsellBusy = false; scheduleUpsell(true); }
  });
  /* Watch only the drawer (Moon re-renders it on every cart change); our own block is ignored to avoid a loop. */
  let watched = null;
  const drawerObserver = new MutationObserver(ms => { if (ms.some(m => !(m.target.closest && m.target.closest('.svl-upsell')))) scheduleUpsell(); });
  new MutationObserver(() => {
    const d = document.getElementById('moonbundle-cart-drawer');
    if (d && d !== watched) { watched = d; drawerObserver.observe(d, { childList: true, subtree: true }); scheduleUpsell(true); }
  }).observe(document.body, { childList: true });
  window.addEventListener('moonbundle-cart-updated', () => scheduleUpsell(true));
  if (document.getElementById('moonbundle-cart-drawer')) { watched = document.getElementById('moonbundle-cart-drawer'); drawerObserver.observe(watched, { childList: true, subtree: true }); }

  /* The "cart" cookie exists only when a cart exists: no network call for shoppers without a cart. */
  if (/(?:^|;\s*)cart=/.test(document.cookie)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule(200)); else schedule(200);
  }
})();
